import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnInit } from '@angular/core';

import { ApiError, MessageService, ButtonLoader } from '../../../../core';
import { ClienteAnaliseMercadoProjecaoSave } from '../cliente-analise-mercado-projecao-save';
import { ClienteAnaliseMercadoProjecaoFormComponent } from '../form';
import { ClienteAnaliseMercadoProjecaoHttpService } from '../services';

@Component({
    selector: 'sgt-cliente-analise-mercado-projecao-form-modal',
    templateUrl: './cliente-analise-mercado-projecao-form-modal.component.html',
    styleUrls: ['./cliente-analise-mercado-projecao-form-modal.component.less']
})
export class ClienteAnaliseMercadoProjecaoFormModalComponent implements OnInit {
    elModal: any;
    /** Se o modal está aberto */
    isOpen = false;
    /** Se está em modo de edição */
    editMode: boolean;

    idCliente: number;

    /** Mês das projeções */
    @Input() mes: number;
    /** Ano das projeções */
    @Input() ano: number;

    @ViewChild('form') form: ClienteAnaliseMercadoProjecaoFormComponent;
    @Output() afterSave = new EventEmitter<ClienteAnaliseMercadoProjecaoSave>();
    @Output() afterCancel = new EventEmitter<number>();

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private clienteAnaliseMercadoProjecaoHttpService: ClienteAnaliseMercadoProjecaoHttpService) { }

    ngOnInit() {
        this.create();
    }

    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                this.isOpen = true;
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.isOpen = false;
                e.stopPropagation();
            });
    }

    /** Abre o modal para adicionar as projeções de vendas mensais para um cliente */
    insert() {
        this.editMode = false;
        this.idCliente = null;
        this.open();
    }

    /** Abre o modal para editar as projeçõe de vendas mensais do cliente */
    edit(idCliente: number) {
        this.editMode = true;
        this.idCliente = idCliente;
        this.open();
    }

    /** Abre o modal */
    private open() {
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    /** Fecha o modal */
    private close() {
        this.idCliente = null;
        this.elModal.modal('hide');
    }

    /** Cancela as alterações nas projeções de vendas mensais do cliente */
    cancel() {
        this.afterCancel.emit(this.idCliente);
        this.close();
    }

    /** Valida se pode realizar o save */
    private validateSave(): boolean {
        if (!this.form?.isValid()) {
            return false;
        }

        return true;
    }

    /** Salva as alterações de vendas mensais do cliente */
    save() {
        if (!this.validateSave()) {
            return false;
        }

        const btn = new ButtonLoader('#btnSaveClienteAnaliseMercadoProjecaoFormModal');
        btn.loading('Salvando');
        const entitySave = this.form?.createEntitySave();
        this.clienteAnaliseMercadoProjecaoHttpService.save(entitySave)
            .subscribe(
                entitySaveResponse => {
                    this.messageService.success('', 'Projeções atualizadas com sucesso');
                    btn.reset();
                    this.afterSave.emit(entitySaveResponse);
                    this.close();
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao atualizar as projeções', error);
                    btn.reset();
                }
            );
    }
}
